import React, { Component } from 'react'
import { observer } from 'mobx-react'
import UIRating from '@ui/QuestionsType/Rating'

@observer
export default class Rating extends Component {
  renderLegends = () => (
    <div className='flex'>
      {this.props.mapped.legends.map(legend => (
        <span key={legend}>{legend}</span>
      ))}
    </div>
  )

  render() {
    const { mapped, onPartial, inactive } = this.props

    return (
      <UIRating
        isCondensed={mapped.isCondensed}
        buttons={mapped.choices}
        onChange={onPartial}
        selected={mapped.answer}
        inactive={inactive}
      >
        {mapped.isCondensed && this.renderLegends()}
      </UIRating>
    )
  }
}
